import { apiClient } from './client';
import type { SpotifyProfile, SpotifyCurrentlyPlaying, SpotifyTrack } from './types';

export class SpotifyAPIError extends Error {
  constructor(
    message: string,
    public status?: number,
    public code?: string
  ) {
    super(message);
    this.name = 'SpotifyAPIError';
  }
}

export class SpotifyRateLimitError extends SpotifyAPIError {
  constructor() {
    super('Spotify API rate limit exceeded', 429, 'RATE_LIMIT_EXCEEDED');
    this.name = 'SpotifyRateLimitError';
  }
}

export const spotify = {
  connect: async (code: string) => {
    try {
      const response = await apiClient.post('/auth/spotify/', {
        code: code,
      });
      
      if (response.status === 200) {
        return response.data;
      }
      
      throw new Error('Failed to connect Spotify account');
    } catch (error) {
      console.error('Spotify connection failed:', error);
      throw error;
    }
  },

  me: async (): Promise<SpotifyProfile> => {
    try {
      const response = await apiClient.get('/spotify/me/');
      return response.data;
    } catch (error) {
      console.error('Failed to fetch Spotify profile:', error);
      throw error;
    }
  },

  currentlyPlaying: async (): Promise<SpotifyCurrentlyPlaying | null> => {
    try {
      const response = await apiClient.get('/spotify/currently-playing/');
      
      if (response.status === 204) {
        return null;
      }

      if (response.status === 429) {
        throw new SpotifyRateLimitError();
      }
      
      return response.data;
    } catch (error) {
      console.error('Failed to fetch currently playing track:', error);
      throw error;
    }
  },

  searchTrack: async (query: string): Promise<SpotifyTrack> => {
    try {
      const response = await apiClient.get('/spotify/search-track/', {
        params: { q: query }
      });
      
      return response.data;
    } catch (error) {
      console.error('Failed to search Spotify tracks:', error);
      throw error;
    }
  },
}; 